function FaqList({ faqs, isSending, updateMessages }) {
  if (!faqs?.length) return null;

  return (
    <ul className={`footer-faqs ${isSending ? 'disable' : ''}`}>
      {faqs.map(
        ({ question, id }) =>
          question && (
            <li key={id} className="faq" onClick={() => updateMessages(question, id)}>
              {question}
            </li>
          )
      )}
    </ul>
  );
}

export default FaqList;
